export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};



// WEBPACK FOOTER //
// ./src/store/utilities/utilities.js